import { Injectable } from '@angular/core'
import { LocalStorageService } from 'ngx-store'

@Injectable({ providedIn: 'root' })
export class LocalAutocompletionService {
  constructor (private localStorage: LocalStorageService) {}

  register<T> (category: string, name: string, value: T|null): void {
    if (!value) {
      return
    }
    const key = `autocompletions:${category}:${name}`
    let list = this.localStorage.get(key)

    if (list === null) {
      this.clear(category, name)
      list = []
    }

    list.push((value as any).toString() as string)
    list = [...new Set(list)]

    this.localStorage.set(key, list)
  }

  clear (category: string, name: string): void {
    const key = `autocompletions:${category}:${name}`
    this.localStorage.set(key, [])
  }

  get (
    category: string, name: string, query?: string|null,
  ): string[] {
    const key = `autocompletions:${category}:${name}`
    const list = this.localStorage.get(key)

    if (list === null) {
      this.clear(category, name)
      return []
    }

    if (!query) {
      return list
    }

    return [...new Set<any>(list.filter(item => {
      return item.toLowerCase().includes(query.toLowerCase())
    }))]
  }
}

const keys = Array.from(Array(localStorage.length).keys()).map(i => localStorage.key(i)!)
for (const key of keys) {
  const value = localStorage.getItem(key)
  if (key.startsWith('ngStorage-autocompletions:') && value) {
    window.localStorage.setItem(key.substring('ngStorage-'.length), value)
    window.localStorage.removeItem(key)
  }
}
